import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

class PaymentsService extends BaseRepository {
  public version = 'v1';
  public collection = 'payments';

  public makeSplitPaymentByPrice(params: GenericMethod) {
    return this.request(params);
  }

  public makeSplitPaymentByProducts(params: GenericMethod) {
    return this.request(params);
  }

  public restorePayments(params: GenericMethod) {
    return this.request(params);
  }

  public restoreItem(params: GenericMethod) {
    return this.request(params);
  }

  public getPaymentsType(params: GenericMethod) {
    return this.request(params);
  }

  public check(params: GenericMethod) {
    return this.request(params);
  }

  public insertEconomicSubscription(params: GenericMethod) {
    return this.request({...params, url: 'economic_subscriptions', method: 'POST'});
  }

  public insertExpenseReport(params: GenericMethod) {
    return this.request({...params, url: 'expenses', method: 'POST'});
  }

  public closeWithDojo(params: GenericMethod) {
    return this.request({...params, url: 'dojo', method: 'POST'});
  }

  public cancelCloseWithDojo(params: GenericMethod) {
    return this.request({...params, url: 'dojo/cancel', method: 'POST'});
  }

  public confirmHandSign(params: GenericMethod) {
    return this.request({...params, url: 'dojo/transaction', method: 'POST'});
  }

  public confirmPayment(params: GenericMethod) {
    return this.request({...params, url: 'dojo/confirmation', method: 'POST'});
  }

  public updateExpenseReport(params: GenericMethod) {
    const id = params.query.id;
    delete params.query.id;
    return this.update({...params, url: `expenses/${id}`});
  }

  public closeWithCashmatic(params: GenericMethod) {
    return this.request({...params, url: 'cashmatic', method: 'POST'});
  }

  public cancelCloseWithCashmatic(params: GenericMethod) {
    return this.request({...params, url: 'cashmatic/cancel', method: 'POST'});
  }

  public changePaymentType(params: GenericMethod) {
    return this.request({...params, url: `change_payment`, method: 'POST'});
  }
}

export default new PaymentsService(axiosInstance);
